import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PricingSection } from '../components/PricingSection';
import { ProductImage } from '../components/ProductImage';
import { IncludesSection } from '../components/IncludesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-cream-50" data-id="element-239">
      <Header data-id="element-240" />
      <main data-id="element-241">
        <Hero data-id="element-242" />
        <PricingSection data-id="element-243" />
        <ProductImage data-id="element-244" />
        <IncludesSection data-id="element-245" />
        <BenefitsSection data-id="element-246" />
        <TestimonialsSection data-id="element-247" />
        <ForWhomSection data-id="element-248" />
        <FAQSection data-id="element-249" />
        <CTASection data-id="element-250" />
      </main>
      <Footer data-id="element-251" />
    </div>;
}